import { Injectable } from '@angular/core';

import { Area, IntercityStop, Product, ProductCategory, RidangoReduxAction } from '@ridango/core';

import { ProductsRequest } from '../products.model';

@Injectable({
    providedIn: 'root'
})
export class ProductActions {
    static PRICELIST_FETCH_START = '[Products]: Pricelist fetch start';
    static PRICELIST_FETCH_SUCCESS = '[Products]: Pricelist fetch success';
    static PRICELIST_FETCH_FAILED = '[Products]: Pricelist fetch failed';
    static PRICELIST_FETCH_END = '[Products]: Pricelist fetch end';

    static SET_PRODUCT_GROUPS = '[Products]: Set pricelist product groups';

    static FETCH_PRODUCTS = '[Products]: Fetch pricelist products';
    static SET_PRODUCTS = '[Products]: Set pricelist products';
    static FETCH_PRODUCTS_FAIL = '[Products]: Fetch pricelist products failed';

    static SET_SELECTED_GROUP_ID = '[Products]: Set selected product group id';
    static SET_SELECTED_PRODUCT_ID = '[Products]: Set selected product id';

    static SET_SELECTED_PRODUCT = '[Products]: Set selected product';

    static SET_MATRIX_PRODUCT_PRICES = '[Products]: Set matrix product prices';

    static SET_FILTERED_PRODUCTS = '[Products] Set filtered products';

    static CLEAR_PRODUCTS = '[Products] Clear products';

    static SET_AREA_FILTER = '[Products] Set area filter';
    static SET_TRAVELLER_CATEGORY_FILTER = '[Products] Set traveller category filter';
    static SET_PRODUCT_CATEGORY_FILTER = '[Products] Set product category filter';

    static APPLY_FILTERS = '[Products] Apply filters';

    pricelistFetchStart(): RidangoReduxAction {
        return {
            type: ProductActions.PRICELIST_FETCH_START
        };
    }

    pricelistFetchSuccess(payload: IntercityStop[]): RidangoReduxAction {
        return {
            type: ProductActions.PRICELIST_FETCH_SUCCESS,
            payload: payload
        };
    }

    pricelistFetchFailed(payload: any): RidangoReduxAction {
        return {
            type: ProductActions.PRICELIST_FETCH_FAILED,
            payload: payload
        };
    }

    pricelistFetchEnd(): RidangoReduxAction {
        return {
            type: ProductActions.PRICELIST_FETCH_END
        };
    }

    setProductGroups(payload: any): RidangoReduxAction {
        return {
            type: ProductActions.SET_PRODUCT_GROUPS,
            payload: payload
        };
    }

    fetchProducts(payload: ProductsRequest): RidangoReduxAction {
        return {
            type: ProductActions.FETCH_PRODUCTS,
            payload: payload
        };
    }

    setProducts(payload: any): RidangoReduxAction {
        return {
            type: ProductActions.SET_PRODUCTS,
            payload: payload
        };
    }

    fetchProductsFail(payload: string): RidangoReduxAction {
        return {
            type: ProductActions.FETCH_PRODUCTS_FAIL,
            payload: payload
        };
    }

    setSelectedGroupId(payload: any): RidangoReduxAction {
        return {
            type: ProductActions.SET_SELECTED_GROUP_ID,
            payload: payload
        };
    }

    setSelectedProductId(productId: any): RidangoReduxAction {
        return {
            type: ProductActions.SET_SELECTED_PRODUCT_ID,
            payload: productId
        };
    }

    setMatrixProductPrices(payload: any): RidangoReduxAction {
        return {
            type: ProductActions.SET_MATRIX_PRODUCT_PRICES,
            payload: payload
        };
    }

    /* products by channel stuff */
    setSelectedProduct(payload: Product): RidangoReduxAction {
        return {
            type: ProductActions.SET_SELECTED_PRODUCT,
            payload: payload
        };
    }

    setFilteredProducts(payload: Product[]): RidangoReduxAction {
        return {
            type: ProductActions.SET_FILTERED_PRODUCTS,
            payload: payload
        };
    }

    clearProducts(): RidangoReduxAction {
        return {
            type: ProductActions.CLEAR_PRODUCTS
        };
    }

    setAreaFilter(area: Area): RidangoReduxAction {
        return {
            type: ProductActions.SET_AREA_FILTER,
            payload: area
        };
    }
    setTravellerCategoryFilter(traveller: ProductCategory): RidangoReduxAction {
        return {
            type: ProductActions.SET_TRAVELLER_CATEGORY_FILTER,
            payload: traveller
        };
    }

    setProductCategoryFilter(product: ProductCategory): RidangoReduxAction {
        return {
            type: ProductActions.SET_PRODUCT_CATEGORY_FILTER,
            payload: product
        };
    }

    applyFilters(): RidangoReduxAction {
        return {
            type: ProductActions.APPLY_FILTERS
        };
    }
}
